import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { DataDirectoryHero } from '../components/data-directory/DataDirectoryHero';
import { DataDirectoryCategoryBrowser } from '../components/data-directory/DataDirectoryCategoryBrowser';
import { DataDirectoryCustomCta } from '../components/data-directory/DataDirectoryCustomCta';
import { DataDirectoryValueProps } from '../components/data-directory/DataDirectoryValueProps';
import { DataDirectoryFAQ } from '../components/data-directory/DataDirectoryFAQ';
import { DataDirectoryCta } from '../components/data-directory/DataDirectoryCta';
export function DataDirectory() {
  const [searchQuery, setSearchQuery] = useState('');
  return <div className="min-h-screen bg-white font-sans selection:bg-blue-100 selection:text-blue-900" data-id="element-4219">
      <Navbar data-id="element-4220" />
      <main data-id="element-4221">
        <DataDirectoryHero searchQuery={searchQuery} setSearchQuery={setSearchQuery} data-id="element-4222" />
        <DataDirectoryCategoryBrowser searchQuery={searchQuery} data-id="element-4223" />
        <DataDirectoryCustomCta data-id="element-4224" />
        <DataDirectoryValueProps data-id="element-4225" />
        <DataDirectoryFAQ data-id="element-4226" />
        <DataDirectoryCta data-id="element-4227" />
      </main>
      <Footer data-id="element-4228" />
    </div>;
}